module.exports = __webpack_public_path__ + "static/media/music.79be28dc.mp3";